import React from 'react';
import {Box, Skeleton} from '@mui/material';
import {styled} from "@mui/material/styles";

const RecentlyBookedCarouselRoot = styled(Box)(() => ({
  boxShadow: '0px 4px 12px 4px rgba(63, 81, 181, 0.05)',
  background: '#FFFFFF',
  borderRadius: '1.5em',
  height: '23em',
  width: '20.64em',
}));

const RecentlyBookedCarouselWrapperPadding = styled(Box)(() => ({
  padding: '1.71em'
}));

const RecentlyBookedCarouselMargin = styled(Box)(() => ({
  marginTop: '1.1em'
}));

const RecentlyBookedCarouselRadius = styled(Skeleton)(() => ({
  borderTopLeftRadius: '1.5em',
  borderTopRightRadius: '1.5em',
}));

const RecentlyBookedCarouselSkeleton = () => {
  return (
    <RecentlyBookedCarouselRoot>
      <RecentlyBookedCarouselRadius variant="rectangular" width={"100%"} height={158}/>
      <RecentlyBookedCarouselWrapperPadding>
        <Skeleton width="30%"/>
        <Skeleton width='60%'/>
        <RecentlyBookedCarouselMargin>
          {[...Array(2).keys()].map((_, index) => <Skeleton variant="text" key={index}/>)}
        </RecentlyBookedCarouselMargin>
      </RecentlyBookedCarouselWrapperPadding>
    </RecentlyBookedCarouselRoot>
  )
}

export default RecentlyBookedCarouselSkeleton
